"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var NoteContent = function NoteContent(_ref) {
  var question = _ref.question,
      onSubmissionChanged = _ref.onSubmissionChanged,
      disabled = _ref.disabled;

  if (!question || !question.includeNotes) {
    return null;
  }

  return _react.default.createElement(_UITextArea.default, {
    value: question.note,
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.notes'),
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onSubmissionChanged(question.set('note', value));
    },
    disabled: disabled,
    resize: disabled ? false : 'vertical',
    "data-selenium-test": "q-and-a-notes"
  });
};

NoteContent.propTypes = {
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default),
  onSubmissionChanged: _react.PropTypes.func,
  disabled: _react.PropTypes.bool
};
var _default = NoteContent;
exports.default = _default;
module.exports = exports.default;